export const state = () => ({
  listAddress: []
})


export const mutations = {
  initialiseStore(state, list) {
    state.listAddress = list;
  }
}
